import { FC, Suspense, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import BaseExperienceApp from './base/App';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';
import { selectedTargetGroup, setTargetGroup } from '../../redux/reducers/targetGroupSlice';
import { getCurrentTarget } from '../../graphQLOperations/StudentSingleSkill';
import { StudentSingleSkillTargetGroupQuery } from '../../graphQLOperations/__generated__/StudentSingleSkillTargetGroupQuery.graphql';
import { TargetGroup } from '../../models/TargetGroup';
import { MainFallback } from '../../components/Fallback/MainFallBack';

const APP_HEADER_OFFSET_PX = 104;
const ACCESSIBILITY_TOOLBAR_OFFSET_PX = 36;

const TargetGroupGate: FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const userRedux = useAppSelector(selectUser);
  const targetGroupRedux = useAppSelector(selectedTargetGroup);

  const { currentTargetGroupByStudentId } = useLazyLoadQuery<StudentSingleSkillTargetGroupQuery>(getCurrentTarget, {
    studentId: `StudentNode:${userRedux?.id}`,
    skip: !!targetGroupRedux?.id,
  });

  useEffect(() => {
    if (currentTargetGroupByStudentId && !targetGroupRedux) {
      dispatch(setTargetGroup(currentTargetGroupByStudentId.targetGroup as TargetGroup));
    }
  }, [currentTargetGroupByStudentId, targetGroupRedux, dispatch]);

  if (!targetGroupRedux?.id) return <MainFallback />;
  return <>{children}</>;
};

export const Skill213Replacement: FC = () => {
  return (
    <div
      className="tw-flex tw-flex-col tw-overflow-visible tw-pb-2 tw-pt-1 md:tw-pb-3"
      style={{
        height: `calc(100dvh - ${APP_HEADER_OFFSET_PX + ACCESSIBILITY_TOOLBAR_OFFSET_PX}px)`,
        backgroundColor: 'var(--background)',
        color: 'var(--foreground)',
      }}
    >
      <div className="tw-min-h-0 tw-flex-1 tw-flex tw-flex-col">
        <Suspense fallback={<MainFallback />}>
          <TargetGroupGate>
            <BaseExperienceApp />
          </TargetGroupGate>
        </Suspense>
      </div>
    </div>
  );
};
